import * as Yup from 'yup';

/**
 * https://stackoverflow.com/questions/19605150/regex-for-password-must-contain-at-least-eight-characters-at-least-one-number-a
 */
export const passwordValidation = Yup.string()
  .required('required')
  .min(8, 'min8')
  .matches(/^(?=.*[A-Z])/, 'one_uppercase')
  .matches(/^(?=.*[a-z])/, 'one_lowercase')
  .matches(/^(?=.*[0-9])/, 'one_number');
